module.exports = __webpack_public_path__ + "img/一体机.c19e3d42.svg";